import React from 'react'
import MovieBook from "./Projectimages/MovieBook.png";
import Zen from "./Projectimages/zenclass.png";
import myschool from "./Projectimages/myschool.png";

function Projectsmall() {
  return (
    <div>
    
    </div>
  )
}

export default Projectsmall
